"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIdentifierType = void 0;
var UserIdentifierType;
(function (UserIdentifierType) {
    // "Standard" are issued by the organization, typically through a physical cards issued to members, entered into our system by the organization.
    UserIdentifierType[UserIdentifierType["STANDARD"] = 0] = "STANDARD";
    // "Global Digital" (aka. "Bond ID" or "Digital Passes") are automatically issued by the system and available digitally (eg. a QR code in an email).
    // They are linked to a User (not a Customer) and may be used by any Organization or Facility where that User is a Customer.
    UserIdentifierType[UserIdentifierType["GLOBAL_DIGITAL"] = 1] = "GLOBAL_DIGITAL";
})(UserIdentifierType = exports.UserIdentifierType || (exports.UserIdentifierType = {}));
//# sourceMappingURL=user-identifier.types.js.map